import React from 'react';
import styles from './styles.module.scss';

const Loader = () => (
  <div className={styles.loader}>
    <div className={styles.ball} />
    <div className={styles.ball} />
    <div className={styles.ball} />
  </div>
);

export default Loader;
